<a [routerLink]="{ cxRoute: 'product', params: product } | cxUrl" class="cx-product-image-container" tabindex="-1">
  <cx-media class="cx-product-image" [container]="product.images?.PRIMARY" [alt]="product.summary"></cx-media>
</a>
<a
  [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
  class="cx-product-name"
  [innerHTML]="product.nameHtml"
></a>

<div class="cx-product-rating">
  @if (!product.averageRating) {
    <div>
      {{ 'productDetails.noReviews' | cxTranslate }}
    </div>
  }
</div>
<div class="cx-product-price-container">
  <div class="cx-product-price" aria-label="Product price">
    {{ product.price?.formattedValue }}
  </div>
</div>

@if (product.variantOptions) {
  <div class="cx-variant-style-icons">
    <cx-variant-style-icons [variants]="product.variantOptions"></cx-variant-style-icons>
  </div>
}

@if (product.stock?.stockLevelStatus !== 'outOfStock') {
  <app-custom-add-to-cart
    [showQuantity]="false"
    [product]="product"
  ></app-custom-add-to-cart>
}
